import styled from '@emotion/styled';
import { Icon, Text } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

import NakedButton from '@/components/LinkButton/LinkButton';

const StyledButton = styled(NakedButton)`
  display: flex;
  align-items: center;
  gap: 0.25rem;

  :focus {
    outline: none;
  }

  :focus-visible {
    outline: 2px solid ${themeGet('colors.brand.secondary')};
  }
`;

const ExpandIcon = styled(Icon)`
  transition: transform 0.2s ease-in-out;
  ${(props: { isExpanded: boolean }) =>
    props.isExpanded && `transform: rotate(180deg);`}
`;

export interface ExpandButtonProps {
  isExpanded: boolean;
  onClick: () => void;
}

export const ExpandButton = ({ onClick, isExpanded }: ExpandButtonProps) => {
  return (
    // TODO: this should be fixed when withProps is converted (pending React 19)
    // @ts-expect-error children is valid prop
    <StyledButton onClick={onClick}>
      <Text
        fontSize="sm"
        lineHeight="27px"
        fontWeight="bold"
        color="brand.primary"
      >
        {isExpanded ? 'Show less' : 'Show more '}
      </Text>
      <ExpandIcon
        color="brand.primary"
        isExpanded={isExpanded}
        name="expandMore"
      />
    </StyledButton>
  );
};
